import { gql } from '@apollo/client';
import { OrganizationNote } from '../types/organizationNote';
import { OrganizationNoteFieldsFragment } from '../fragments/organizationNote';

export interface CreateOrganizationNoteRequest {
  data: {
    organizationId: string;
    content: string;
  };
}

export interface CreateOrganizationNoteResponse {
  createOrganizationNote: OrganizationNote;
}

export const CREATE_ORGANIZATION_NOTE = gql`
  mutation CreateOrganizationNote($data: CreateOrganizationNoteInput!) {
    createOrganizationNote(data: $data) {
      ...OrganizationNoteFields
    }
  }
  ${OrganizationNoteFieldsFragment}
`;
